import router from '@/router';

const triggerers = {
  projectDeadlineTriggerer(): 'change' | 'blur' {
    return router.currentRoute.fullPath.includes('?project') ? 'change' : 'blur';
  },

  pricePerAssessmentTriggerer(): 'change' | 'blur' {
    return router.currentRoute.fullPath.includes('?project') ? 'change' : 'blur';
  },
};

export default triggerers;
